import { render, staticRenderFns } from "./createMaterialLabel.vue?vue&type=template&id=2636b369&scoped=true"
import script from "./createMaterialLabel.vue?vue&type=script&lang=js"
export * from "./createMaterialLabel.vue?vue&type=script&lang=js"
import style0 from "./createMaterialLabel.vue?vue&type=style&index=0&id=2636b369&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2636b369",
  null
  
)

export default component.exports